<script setup lang="ts">
  defineEmits<{ click: [] }>();
</script>

<template>
  <div
    class="contain-strict cursor-pointer flex w-full h-8 px-[11px] py-2.5 justify-center items-center gap-2.5 shrink-0 rounded-lg border border-[#0080FF] bg-white/5 shadow-[0_4px_8px_0_rgba(0,0,0,0.35)] backdrop-blur-xl font-['Barlow'] text-white -mb-2 sm:[&>p]:text-lg sm:[&_span]:text-lg lg:rounded-xl lg:h-[42px] lg:max-w-[1058px] lg:[&>p]:text-2xl lg:[&_span]:text-2xl 2xl:max-w-[1448px]"
    @click="$emit('click')"
  >
    <p
      class="text-center [text-shadow:2px_2px_2px_rgba(0,0,0,0.5)] text-xs sm:text-sm font-bold leading-[120%] uppercase"
    >
      Sign up now and try the games for
      <span class="text-[#5bb5fa]">FREE</span>
    </p>
  </div>
</template>
